'use client';

import { ReactNode } from 'react';
import { cn } from '@ncai-axe/react-ui-v3';
import styles from './styles.module.scss';

interface IAccordionList {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}
export const AccordionList = ({
  children,
  className,
  style,
}: IAccordionList) => {
  return (
    <ul className={cn(styles.accordionList, className)} style={style}>
      {children}
    </ul>
  );
};
